import styled, { css } from "styled-components"

export const Label = styled.label`
  display: block;
  color: #1f1f23;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  text-align: left;
  ${props =>
    props.required &&
    css`
      &::after {
        margin-left: 2px;
        content: "*";
        color: red;
      }
    `};
`

export const Error = styled.div`
  color: red;
  font-size: 14px;
  font-weight: 500;
  margin-top: 6px;
`
